import React from 'react';

const PhoneControlsActionContainerButtonDivider = () => {
  return <div className="phoneControlsActionContainer-buttonDivider" />;
};

export default PhoneControlsActionContainerButtonDivider;
